export const WhyList = [
    {
      title: "Kurikulum Terbaik",
      icon: "/icon_corporate-1.png",
      list: [
        "Kurikulum terbaru dan terbaik",
        "Pembelajaran melalui modul",
        "Sistematis dan suportif",
        "Kompetitif dan konkret",
      ],
    },
    {
      title: "Harga Spesial",
      icon: "/icon_corporate-2.png",
      list: [
        "Harga kompetitif",
        "Value for money",
        "Guarantee program",
        "Paket program terbaik",
      ],
    },
    {
      title: "Instruktur Profesional",
      icon: "/icon_corporate-3.png",
      list: [
        "Tersertifikasi",
        "Berpengalaman dalam bidang",
        "Pelatihan terupdate",
        "Live-support setelah pelatihan",
      ],
    },
]
